export default class ContractLink {
  id: string;

  link: string;

  description: string;

  activated: boolean;

  createdDate?: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.link = obj.link || '';
    this.description = obj.description || '';
    this.activated = obj.activated === undefined ? true : obj.activated;
    this.createdDate = obj.createdDate || '';
  }

  public static of(obj: any): ContractLink {
    return new ContractLink(obj);
  }

  public static ofList(obj: any[]): ContractLink[] {
    return obj.map(this.of)
  }

  get status(): string {
    return this.activated ? 'ativo' : 'inativo';
  }

  get isNew(): boolean {
    return this.id === '' && this.link === '' && this.description === '';
  }

  get isActivated(): boolean {
    return this.activated;
  }
}
